import React from 'react'
import { Box, Stack, Button, Badge } from '@mui/material'
import FilterButton from 'components/FilterButton'
import PropTypes from 'prop-types'
import GetAppIcon from '@mui/icons-material/GetApp'
import { useConversionReport } from 'hooks/useConversionReport'
import { ExportButton } from '../styles'
import useExportAdsReport from 'mutations/useExportAdsReport'

export default function ActionButtons({ toggleDrawer }) {
  const { state, actions } = useConversionReport()
  const { mutate } = useExportAdsReport()

  const isCampaign = state.search === 'campaign'
  const isFilterActive = state.ads?.length > 0 || state.campaigns?.length > 0 || state.statuses?.length > 0

  return (
    <Stack marginY="1rem" display="flex" flexDirection="row" justifyContent="space-between">
      <Box display="flex" width="70%">
        <Button
          variant={isCampaign ? 'contained' : 'outlined'}
          sx={{
            borderRadius: '4px 0 0 4px',
            '&.HiTheme-Button-contained': {
              backgroundColor: '#00aeef',
            },
            '&.HiTheme-Button-outlined': {
              borderColor: '#00aeef',
              color: '#00aeef',
            },
          }}
          data-testid="campaign-button"
          onClick={() => {
            actions.setAds([])
            actions.setSearch('campaign')
          }}
        >
          Por campanha
        </Button>
        <Button
          variant={!isCampaign ? 'contained' : 'outlined'}
          sx={{
            borderRadius: '0 4px 4px 0',
            '&.HiTheme-Button-contained': {
              backgroundColor: '#00aeef',
            },
            '&.HiTheme-Button-outlined': {
              borderColor: '#00aeef',
              color: '#00aeef',
            },
          }}
          data-testid="advertisement-button"
          onClick={() => {
            actions.setSearch('ad_id')
          }}
        >
          Por anúncio
        </Button>
      </Box>
      <Box display="flex" width="30%" justifyContent="flex-end" gap={2}>
        <ExportButton
          data-testid="export-button"
          onClick={() => {
            mutate({
              adAccountId: state.adAccountId,
              startDate: state.date.start,
              endDate: state.date.end,
              groupBy: state.search,
              campaigns: state.campaigns, 
              ads: state.ads, 
              statuses: state.statuses, 
            })
          }}
        >
          <GetAppIcon />
          Exportar
        </ExportButton>
        <Badge variant="dot" badgeContent=" " color={isFilterActive ? 'error' : 'transparent'}>
          <FilterButton handleClick={toggleDrawer} />
        </Badge>
      </Box>
    </Stack>
  )
}

ActionButtons.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
}
